import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuthState, useAuthDispatch, logout } from 'context';
import { MainLayout } from 'components/layout/mainLayout';
import { isMobile } from 'components/utils';
import Logo from 'assets/images/logo.svg';
import Logo2 from 'assets/images/logo2.svg';
import Logo3 from 'assets/images/content/old-men-1.svg';
import Login from 'assets/images/svg/icon_in.svg';
import Person from 'assets/images/svg/icon_person.svg';
import Avatar from 'assets/images/svg/avatar.svg';
import Longevity from 'assets/images/content/longevity.svg';
import OldMen from 'assets/images/content/old-men.svg';
import Figure from 'assets/images/content/app-figure.svg';
import Contest1 from 'assets/images/content/contest/contest_1.svg';
import Contest2 from 'assets/images/content/contest/contest_2.svg';
import Contest3 from 'assets/images/content/contest/contest_3.svg';
import Contest4 from 'assets/images/content/contest/contest_4.svg';
import Contest5 from 'assets/images/content/contest/contest_5.svg';
import ErLogo from 'assets/images/content/er-logo.svg';
import MinTrud from 'assets/images/content/mintrud.png';
import Contest_1 from 'assets/images/content/contest/m-1.svg';
import Contest_2 from 'assets/images/content/contest/m-2.svg';
import Contest_3 from 'assets/images/content/contest/m-3.svg';
import Contest_4 from 'assets/images/content/contest/m-4.svg';
import Contest_5 from 'assets/images/content/contest/m-5.svg';
import Doc_wh from 'assets/images/svg/icon-doc-wh.svg';
import { MainVotes } from 'components/votes';

export const Main = () => {
	const { userDetails, token } = useAuthState();
	const history = useHistory();
	const dispatch = useAuthDispatch();

	const handleLogout = () => {
		logout(dispatch);
		history.push('/login');
	};

	return (
		<MainLayout>
			<section className='main'>
				<div className='main__bg'>
					<header id='header'>
						<div className='container'>
							{history.location.pathname !== '/' && !isMobile && (
								<p className='header_text'>
									<span>Прямая связь</span>
									<br></br>
									<span>платформа сторонников единой россии</span>
								</p>
							)}
							{userDetails.name ? (
								<div className='details'>
									<Link className='' to={'/profile'}>
										<div>
											<img src={Avatar} alt='ava' />
										</div>
										<div className='details_text'>
											<span>{userDetails.surname}</span>
											<br></br>
											<span>
												{userDetails.name} {userDetails.patronymic}
											</span>
										</div>
									</Link>
									<img
										className='main__icon-in'
										onClick={handleLogout}
										src={Login}
										alt='person'
									/>
								</div>
							) : (
								<Link className='main__btn-in' to={'/login'}>
									<img
										className='main__icon-person'
										src={Person}
										alt='person'
									/>
									Вход / Регистрация
									<img className='main__icon-in' src={Login} alt='person' />
								</Link>
							)}
						</div>
					</header>

					<div className='container'>
						<div className='main__logo-block'>
							<Link className='logo_link2' to={'/'}>
								<img src={Logo2} alt={'logo'} />
							</Link>
							<Link className='logo_link4' to={'/'}>
								<img src={Logo3} alt={'logo'} />
							</Link>
							<Link className='logo_link' to={'/'}>
								<img src={Logo} alt={'logo'} />
							</Link>
						</div>
						<div className='main__top-block'>
							<h1 className='main__title'>Долголетие для всех</h1>
							<p className='main__caption'>
								Всероссийский конкурс лучших практик работы <br />
								с людьми старшего поколения
							</p>
						</div>
						<div className='main__bottom-block'>
							<div className='main__left-block'>
								<p className='main__text'>
									Конкурс проводится в целях развития региональной
									инфраструктуры <br />
									для досуга граждан старшего поколения и привлечения внимания{' '}
									<br />
									в целом к вопросу работы с людьми «серебряного» возраста
								</p>
								<div className='main__date-text'>
									НАРОДНОЕ ГОЛОСОВАНИЕ ЗАВЕРШЕНО
								</div>
								<Link to={token ? '/voting' : '/profile'}>
									<button className='main__btn button' type='button'>
										{token ? 'Посмотреть результаты' : 'Зарегистрироваться'}
									</button>
								</Link>
								<a href='/docs/winners.pdf' target={'_blank'}>
									<button className='main__btn button' type='button'>
                  Победители
									</button>
								</a>
							</div>
							<div className='main__right-block'>
								<div className='main__app-figure'>
									<img src={Figure} alt='' />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className='contest'>
				<div className='container contest__container'>
					<div className='contest__intro'>
						<div className='contest__intro-about'>
							<div className='contest__title title'>О конкурсе:</div>
							<ul className='contest__intro-list'>
								<li>Участие в конкурсе лучших практик — это возможность: </li>
								<li>
									<ul>
										<li>Представить свою работу</li>
										<li>Рассказать о своём проекте</li>
										<li>Получить грант на реализацию проекта</li>
									</ul>
								</li>
							</ul>
						</div>
						<div className='contest__intro-right'>
							<div className='contest__title title'>
								Участниками конкурса могут стать:
							</div>
							<ul className='contest__intro-list'>
								<li>
									<ul>
										<li>некоммерческие организации</li>
										<li>общественные объединения</li>
										<li>центры «серебряного» волонтерства</li>
									</ul>
								</li>
							</ul>
							<p className='contest__intro-text'>
								*представляющие свою деятельность (за последние 2 года) и
								предлагающие социально значимый проект для представителей
								старшего поколения
							</p>
						</div>
					</div>
					<div className='contest__wrap'>
						<div className='contest__block'>
							<h2 className='contest__title title'>Задачи</h2>
							<div className='contest__d-flex'>
								<div className='contest__item'>
									<div className='contest__icon'>
										<picture>
											<source media='(max-width: 768px)' srcSet={Contest_1} />
											<img src={Contest1} alt='' />
										</picture>
									</div>

									<div className='contest__text text-s18'>
										Выявить и обнародовать наиболее интересные и актуальные
										практики работы некоммерческих организаций, центров
										социального обслуживания населения, тематических клубов для
										людей старшего поколения.
									</div>
								</div>
								<div className='contest__item'>
									<div className='contest__icon'>
										<picture>
											<source media='(max-width: 768px)' srcSet={Contest_2} />
											<img src={Contest2} alt='' />
										</picture>
									</div>

									<div className='contest__text text-s18'>
										Привлечь внимание органов государственной власти, местного
										самоуправления, общественности к вопросам обеспечения
										содержательного досуга для лиц старшего возраста.
									</div>
								</div>
								<div className='contest__item'>
									<div className='contest__icon'>
										<picture>
											<source media='(max-width: 768px)' srcSet={Contest_3} />
											<img src={Contest3} alt='' />
										</picture>
									</div>

									<div className='contest__text text-s18'>
										Создать условия для поддержки наиболее успешных практик
										работы и их тиражирования.
									</div>
								</div>
								<div className='contest__item'>
									<div className='contest__icon'>
										<picture>
											<source media='(max-width: 768px)' srcSet={Contest_4} />
											<img src={Contest4} alt='' />
										</picture>
									</div>

									<div className='contest__text text-s18'>
										Обеспечить поддержку инициатив, которые поддерживают сами
										жители в результате открытого рейтингового голосования.
									</div>
								</div>
								<div className='contest__item'>
									<div className='contest__icon'>
										<picture>
											<source media='(max-width: 768px)' srcSet={Contest_5} />
											<img src={Contest5} alt='' />
										</picture>
									</div>

									<div className='contest__text text-s18'>
										Выявить восемь лучших проектов, которые получат гранты на
										реализацию своей инициативы.
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className='contest__bottom'>
						<h3 className='contest__bottom-title'>
							8 победителям конкурса вручат денежные <br />
							сертификаты на реализацию своих проектов
						</h3>
						<div className='contest__bottom-line'></div>
						<div className='contest__bottom-row'>
							<a
								href='/docs/Положение_о_конкурсе_Долголетие_для_всех.pdf'
								className='contest__dwn'
								download
							>
								<span>Положение о конкурсе</span>
								<img src={Doc_wh} alt='' />
							</a>
							<a
								href='/docs/ER-site-Konkurs-Granma.pdf'
								className='contest__dwn'
								download
							>
								<span>Презентация о конкурсе</span>
								<img src={Doc_wh} alt='' />
							</a>
						</div>
					</div>
				</div>
			</section>

			<MainVotes />

			<section className='calendar'>
				<div className='container'>
					<h2 className='calendar__title title'>Календарь конкурса</h2>
					<div className='calendar__timeline'>
						<div className='calendar__timeline-item'>
							<div className='calendar__timeline-date'>
								12.07.2022–12.08.2022
							</div>
							<div className='calendar__timeline-text'>подача заявок</div>
						</div>
						<div className='calendar__timeline-item'>
							<div className='calendar__timeline-date'>
								22.08.2022–1.09.2022
							</div>
							<div className='calendar__timeline-text'>
								открытое голосование
							</div>
						</div>
						<div className='calendar__timeline-item'>
							<div className='calendar__timeline-date'>1.09.2022–7.09.2022</div>
							<div className='calendar__timeline-text'>
								голосование Экспертного совета
							</div>
						</div>
						<div className='calendar__timeline-item'>
							<div className='calendar__timeline-date'>20.09.2022</div>
							<div className='calendar__timeline-text'>
								награждение победителей
							</div>
						</div>
					</div>
					<div className='calendar__wrap'>
						<div className='calendar__card'>
							<div className='calendar__card-title text-s24'>
								старт <br /> конкурса
							</div>
							<div className='calendar__card-date text-s24'>
								<span>12</span> <br /> июля
							</div>
						</div>
						<div className='calendar__card'>
							<div className='calendar__card-title text-s24'>
								окончание <br />
								приема заявок
							</div>
							<div className='calendar__card-date text-s24'>
								<span>12</span> <br /> августа
							</div>
						</div>
						<div className='calendar__card'>
							<div className='calendar__card-title text-s24'>
								открытое
								<br /> голосование
							</div>
							<div className='calendar__card-date text-s24'>
								<div className='calendar__card-double'>
									<div>
										<span>22</span> <br /> августа
									</div>
									<span>-</span>
									<div>
										<span>1</span> <br /> сентября
									</div>
								</div>
							</div>
						</div>
						<div className='calendar__card'>
							<div className='calendar__card-title text-s24'>
								подведение <br /> итогов
							</div>
							<div className='calendar__card-date text-s24'>
								<span>7</span> <br /> сентября
							</div>
						</div>
						<div className='calendar__card'>
							<div className='calendar__card-title text-s24'>
								награждение <br /> победителей
							</div>
							<div className='calendar__card-date text-s24'>
								<span>20</span> <br /> сентября
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <div className='container'>
				<div className='calendar__banner'>
					<div className='calendar__banner-text'>
						<h3>Принять участие в народном голосовании</h3>
						<span>
							Для принятия в голосовании вам необходимо зарегистрироваться или
							авторизоваться
						</span>
					</div>

					<Link to={'/voting'}>
					<button className='main__btn button' type='button'>
						Проголосовать
					</button>
					</Link>
				</div>
			</div> */}
			<section className='sponsor'>
				<div className='container'>
					<div className='sponsor__wrap'>
						<div className='sponsor__block'>
							<h3 className='sponsor__title text-s24'>Организатор</h3>
							<div className='sponsor__row sponsor__row_first'>
								<div className='sponsor__item sponsor__item_row'>
									<div className='sponsor__logo'>
										<img src={ErLogo} alt='' />
									</div>
									<div className='sponsor__logo-text'>
										Всероссийская политическая <br /> партия
										«Единая&nbsp;Россия»
									</div>
								</div>
								<div className='sponsor__item sponsor__item_sm'>
									<div className='sponsor__logo'>
										<img src={OldMen} alt='' />
									</div>
									<div className='sponsor__logo-text'>
										<span>Старшее поколение</span>
									</div>
								</div>
								<div className='sponsor__item'>
									<div className='sponsor__logo'>
										<img src={Longevity} alt='' />
									</div>
									<div className='sponsor__logo-text'>
										<span>
											Направление «Долголетие для всех» мобилизационного
											партийного проекта «Старшее поколение»
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className='sponsor__block'>
							<div className='sponsor__row sponsor__row_second'>
								<div className='sponsor__item sponsor__item_third'>
									<h3 className='sponsor__title text-s24'>Партнеры</h3>
									<div className='sponsor__logo'>
										<img src={MinTrud} alt='' />
									</div>
								</div>
								<div className='sponsor__item sponsor__item_last'>
									<h3 className='sponsor__title text-s24'>Обратная связь</h3>
									<p className='sponsor__contacts'>
										<span>
											125009, Москва, Тверской район, Георгиевский переулок, 2
										</span>
										<span>
											Телефон:{' '}
											<a href='tel:+7 (495) 692 32 61'>+7 (495) 692 32 61</a>
										</span>
										<span>
											Email:{' '}
											<a href='mailto:a.dolgoletie@edinros.ru'>
												a.dolgoletie@edinros.ru
											</a>
										</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</MainLayout>
	);
};
